export function installSegmentIntegration() {
  let integrationType: "segment" | "segmentNext" | null = null;
  let tries = 20;

  function getAnalytics() {
    if (integrationType === "segment") {
      return window.analytics;
    }

    if (integrationType === "segmentNext") {
      return window.analyticsNext;
    }

    return null;
  }

  async function getUser() {
    if (integrationType === "segment") {
      return window.analytics.user();
    }

    if (integrationType === "segmentNext") {
      return await window.analyticsNext.user();
    }

    return null;
  }

  function findIntegrationType() {
    if ("analytics" in window) {
      integrationType = "segment";
    }

    if ("analyticsNext" in window) {
      integrationType = "segmentNext";
    }
  }

  function whenAnalyticsReady(callback: (analytics: any) => void) {
    if (!integrationType) {
      findIntegrationType();
    }

    if (getAnalytics()) {
      const analytics = getAnalytics();
      analytics.ready(callback);
    } else {
      if (tries-- > 0) {
        setTimeout(() => whenAnalyticsReady(callback), 200);
      }
    }
  }

  async function identify(ctx?: any) {
    try {
      const user = await getUser();
      window.pyne("identify", user.id(), user.traits());
    } catch (e) {
      console.error(e);
    }
  }

  const segmentPlugin = {
    name: "Pyne",
    type: "destination",
    version: "1.0.0",

    isLoaded: () => true,
    load: () => Promise.resolve(),

    identify: (ctx: any) => {
      identify(ctx);
      return ctx;
    },
  };

  whenAnalyticsReady(() => {
    const analytics = getAnalytics();
    analytics.register(segmentPlugin);
    identify();
  });
}
